exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loader-box{padding-top:50px;text-align:center\n}\n.loader-box img{width:50px\n}", "", {"version":3,"sources":["/home/rof/src/github.com/Multibrain/OneMB/resources/assets/js/components/loading.vue"],"names":[],"mappings":";AAAA,YAAY,iBAAiB,iBAAiB;CAAC;AAAA,gBAAgB,UAAU;CAAC","file":"loading.vue","sourcesContent":[".loader-box{padding-top:50px;text-align:center}.loader-box img{width:50px}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5feb5116","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/loading.vue
// module id = 646
// module chunks = 72